(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var routes = (window.Theme && window.Theme.routes) || {};
    var cartUrl = routes.cart_url || '/cart';
    var cartChangeUrl = (routes.cart_change_url || '/cart/change') + '.js';
    var cartUpdateUrl = (routes.cart_change_url || '/cart/change').replace(/change$/, 'update') + '.js';

    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) {
      return;
    }

    var content = drawer.querySelector('[data-cart-drawer-content]');
    var overlay = drawer.querySelector('[data-cart-drawer-overlay]');
    var lastFocused = null;
    var pendingChange = null;

    function sectionUrl() {
      var base = window.location.pathname === '/' ? cartUrl : window.location.pathname;
      var separator = base.indexOf('?') === -1 ? '?' : '&';
      return base + separator + 'section_id=cart-drawer';
    }

    function extractSectionHtml(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var wrapped = parsed.getElementById('shopify-section-cart-drawer');
      return wrapped ? wrapped.innerHTML : html;
    }

    function updateHeaderCount(count) {
      var badge = document.querySelector('[data-header-cart-count]');
      if (badge) {
        badge.textContent = count > 0 ? count : '';
        badge.setAttribute('data-header-cart-count', count > 0 ? count : '');
        badge.classList.toggle('visible', count > 0);
      }
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: { count: count } }));
    }

    function updateMinusButtons() {
      content.querySelectorAll('[data-cartitem-key]').forEach(function (item) {
        var input = item.querySelector('[data-quantity-input]');
        var minusWrapper = item.querySelector('[data-button-wrapper-minus]');
        if (!input || !minusWrapper) {
          return;
        }
        var incrementValue = parseInt(input.getAttribute('data-increment-value'), 10) || 1;
        var count = parseInt(input.value, 10) || 0;
        minusWrapper.classList.toggle('quantity-selector__button-wrapper--disabled', count <= incrementValue);
      });
    }

    function animateShippingProgress(previousWidth) {
      var bar = content.querySelector('[data-cart-drawer-shipping-progress]');
      if (!bar) {
        return;
      }
      var target = bar.style.width;
      if (previousWidth) {
        bar.style.transition = 'none';
        bar.style.width = previousWidth;
        // Force a reflow so the browser registers the starting width
        // before the transition below is allowed to animate to target.
        void bar.offsetWidth;
        bar.style.transition = '';
      }
      requestAnimationFrame(function () {
        bar.style.width = target;
      });
    }

    function refreshDrawer() {
      var existingBar = content.querySelector('[data-cart-drawer-shipping-progress]');
      var previousWidth = existingBar ? existingBar.style.width : null;

      return fetch(sectionUrl(), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then(function (html) {
          content.innerHTML = extractSectionHtml(html);
          updateMinusButtons();
          animateShippingProgress(previousWidth);
        })
        .catch(function () {
          content.innerHTML = '<div class="cart-drawer__empty"><p>' +
            'Something went wrong loading your cart.' +
            '</p></div>';
        });
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refreshDrawer();
      var closeButton = drawer.querySelector('[data-cart-drawer-close]');
      if (closeButton) {
        closeButton.focus();
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused) {
        lastFocused.focus();
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cart-drawer-trigger]');
      if (trigger) {
        event.preventDefault();
        openDrawer();
        return;
      }

      if (event.target.closest('[data-cart-drawer-close]') || event.target === overlay) {
        event.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    function closeShippingInfoPopup() {
      var popup = content.querySelector('[data-cart-drawer-shipping-info-popup]');
      var toggle = content.querySelector('[data-cart-drawer-shipping-info-toggle]');
      if (popup) {
        popup.hidden = true;
      }
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    content.addEventListener('click', function (event) {
      var infoToggle = event.target.closest('[data-cart-drawer-shipping-info-toggle]');
      if (infoToggle) {
        event.preventDefault();
        event.stopPropagation();
        var container = infoToggle.closest('[data-cart-drawer-shipping-info]');
        var popup = container ? container.querySelector('[data-cart-drawer-shipping-info-popup]') : null;
        if (popup) {
          var wasHidden = popup.hidden;
          closeShippingInfoPopup();
          if (wasHidden) {
            popup.hidden = false;
            infoToggle.setAttribute('aria-expanded', 'true');
          }
        }
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-drawer-shipping-info-popup]')) {
        return;
      }
      closeShippingInfoPopup();
    });

    function changeItem(key, quantity) {
      return fetch(cartChangeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          updateHeaderCount(cart.item_count);
          return refreshDrawer();
        });
    }

    content.addEventListener('click', function (event) {
      var removeLink = event.target.closest('[data-cartitem-remove]');
      if (removeLink) {
        event.preventDefault();
        var item = removeLink.closest('[data-cartitem-key]');
        if (item) {
          changeItem(item.getAttribute('data-cartitem-key'), 0);
        }
        return;
      }

      var minusButton = event.target.closest('[data-quantity-minus]');
      var plusButton = event.target.closest('[data-quantity-plus]');
      if (minusButton || plusButton) {
        var item2 = event.target.closest('[data-cartitem-key]');
        if (!item2) {
          return;
        }
        var input = item2.querySelector('[data-quantity-input]');
        if (!input) {
          return;
        }
        var incrementValue = parseInt(input.getAttribute('data-increment-value'), 10) || 1;
        var current = parseInt(input.value, 10) || incrementValue;
        if (minusButton && current <= incrementValue) {
          return;
        }
        var next = minusButton ? current - incrementValue : current + incrementValue;
        input.value = next;
        updateMinusButtons();
        if (pendingChange) {
          clearTimeout(pendingChange);
        }
        var key = item2.getAttribute('data-cartitem-key');
        pendingChange = setTimeout(function () {
          changeItem(key, next);
        }, 150);
      }
    });

    content.addEventListener('change', function (event) {
      var input = event.target.closest('[data-quantity-input]');
      if (!input) {
        return;
      }
      var item = input.closest('[data-cartitem-key]');
      if (!item) {
        return;
      }
      var incrementValue = parseInt(input.getAttribute('data-increment-value'), 10) || 1;
      var next = Math.max(incrementValue, parseInt(input.value, 10) || incrementValue);
      input.value = next;
      updateMinusButtons();
      changeItem(item.getAttribute('data-cartitem-key'), next);
    });

    function showDiscountFeedback(message, isError) {
      var feedback = content.querySelector('[data-cart-drawer-discount-feedback]');
      if (!feedback) {
        return;
      }
      feedback.textContent = message;
      feedback.hidden = false;
      feedback.classList.toggle('cart-drawer__discount-feedback--success', !isError);
      feedback.classList.toggle('cart-drawer__discount-feedback--error', isError);
    }

    function applyDiscount() {
      var input = content.querySelector('[data-cart-drawer-discount-input]');
      var applyButton = content.querySelector('[data-cart-drawer-discount-apply]');
      if (!input) {
        return;
      }
      var code = input.value.trim();
      if (!code) {
        return;
      }
      if (applyButton) {
        applyButton.disabled = true;
        applyButton.textContent = 'Applying…';
      }

      fetch(cartUrl + '.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cartBefore) {
          var beforeTitles = (cartBefore.cart_level_discount_applications || []).map(function (d) {
            return d.title;
          });

          return fetch(cartUpdateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: code }),
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (cartAfter) {
              var afterApplications = cartAfter.cart_level_discount_applications || [];
              var afterTitles = afterApplications.map(function (d) {
                return d.title;
              });
              var applied = afterApplications.length > beforeTitles.length ||
                afterTitles.some(function (title) {
                  return beforeTitles.indexOf(title) === -1;
                });

              updateHeaderCount(cartAfter.item_count);

              return refreshDrawer().then(function () {
                var details = content.querySelector('[data-cart-drawer-discount]');
                if (details) {
                  details.setAttribute('open', '');
                }
                if (applied) {
                  showDiscountFeedback('Discount applied.', false);
                } else {
                  showDiscountFeedback('This code is invalid or cannot be applied.', true);
                }
              });
            });
        })
        .catch(function () {
          showDiscountFeedback('Something went wrong. Please try again.', true);
        })
        .then(function () {
          var freshApplyButton = content.querySelector('[data-cart-drawer-discount-apply]');
          if (freshApplyButton) {
            freshApplyButton.disabled = false;
            freshApplyButton.textContent = 'Apply';
          }
        });
    }

    content.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-drawer-discount-apply]')) {
        event.preventDefault();
        applyDiscount();
      }
    });

    content.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.closest('[data-cart-drawer-discount-input]')) {
        event.preventDefault();
        applyDiscount();
      }
    });
  });
})();
